export default __webpack_public_path__ + "static/media/full-control-homepage-img.107d9271.png";